// extracted by mini-css-extract-plugin
export default {"licenseList":"KrK1DhWDkBRSmTVGj0n9","issueSection":"uIIfKeesdJYNTLRtodMa"};